import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import sampleBg from '../../images/sample.png';
import Button from '../Button/index';

class MapPopupCard extends PureComponent {
    render () {
        const { marker, orgWithMultipleEvents } = this.props;

        const slug = (orgWithMultipleEvents.indexOf(marker.organisation.id) !== -1 ? `/livewell-finder/${marker.organisation.slug}/` : `/livewell-finder/${marker.organisation.slug}/${marker.slug}/`);

        return (<div className="map-popup-card">
            <div className="aspect-ratio-image" style={{ backgroundImage: `url(${marker.main_image ? marker.main_image : sampleBg})` }}>
                <div className="inner">
                    <p className="tag-label light">{marker.price === null ? '' : marker.price}</p>
                </div>
            </div>
            <div className="card-content">
                {/* <p className="tag-label">{orgWithMultipleEvents.indexOf(marker.organisation.id) !== -1 ? 'Multiple activities' : 'Single activity'}</p> */}
                <h4>{marker.organisation.name}</h4>
                <a href={slug}>
                    <Button
                        label="Explore"
                        classes="button-round button__secondary-green"
                    />
                </a>

            </div>
        </div>);
    }
}

export default MapPopupCard;
